import { render, staticRenderFns } from "./changeCamera.vue?vue&type=template&id=1182c684&scoped=true"
import script from "./changeCamera.vue?vue&type=script&lang=js"
export * from "./changeCamera.vue?vue&type=script&lang=js"
import style0 from "./changeCamera.vue?vue&type=style&index=0&id=1182c684&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182c684",
  null
  
)

export default component.exports